import React, { Component } from "react";
import { Link } from "react-router-dom";

class AppLogo extends Component {
  render() {
    return (
      <Link to="/" className="text-dark no-underline">
        <h5 className="mb-0 font-serif font-weight-bold">Traduora</h5>
      </Link>
    );
  }
}

export default AppLogo;
